export const config = {

  APPID: 2017091908809974,

  serverBaseUrl1: 'https://api.id-photo-verify.com',

  serverBaseUrl2: 'https://apicall.id-photo-verify.com',
  serverBaseUrl3: 'https://91pitu.com',
  oAuthDomain: 'https://a.id-photo-verify.com',

  get getPhotoBaseUrl() {
    return `${this.serverBaseUrl2}/alipay/take_pic_alipay/`;
  },
  
  get oAuthUrl() {
    return `${this.serverBaseUrl2}/alipay/begin_get_user_id`;
  } 
};
